import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import isElectron from 'is-electron';
import appConfig from 'app-config';
import HomeClient from 'flow/api-clients/home-client';
import { getQueryParam } from 'flow/utils/browser-utils';

class AuthWithToken extends React.PureComponent {
    static propTypes = {
        match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    };

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
        };
    }

    componentDidMount() {
        const { authToken } = this.props.match.params;
        const { location } = this.props;

        if (authToken) {
            if (appConfig.production && !isElectron()) {
                const hostParam = getQueryParam(location.search, 'host');
                if (hostParam) {
                    HomeClient.apiHost = 'https://' + hostParam;
                }
            }
            HomeClient.authToken = authToken;
            this.setState({ redirect: true }); // eslint-disable-line react/no-did-mount-set-state
        }
    }

    render() {
        const {
            match: { params },
        } = this.props;

        const redirectPath = params[0] ? `/${params[0]}` : '/';

        if (this.state.redirect) {
            return <Redirect to={redirectPath} />;
        }

        return null;
    }
}

export default AuthWithToken;
